// Paste your Firebase web app configuration here from Firebase Console > Project settings.
// Setup required: enable Email/Password Authentication and Cloud Firestore in Firebase.
export const firebaseConfig = {
  apiKey: "AIzaSyApoakLZMwvJtY6uDFQbNgf6hupp3JvnpY",
  authDomain: "standardtestpractice.firebaseapp.com",
  projectId: "standardtestpractice",
  storageBucket: "standardtestpractice.firebasestorage.app",
  messagingSenderId: "812357519141",
  appId: "1:812357519141:web:767bb74d1b46d1d2313ccc",
  measurementId: "G-3169959VQS"
};

export const isFirebaseConfigured = !Object.values(firebaseConfig).some((value) => String(value).startsWith('PASTE_'));
